// src/pages/driver/driverJobList/SkipModal.jsx — confirmation modal for skipping a stop
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function SkipModal({ open, target, onCancel, onConfirm }) {
  const [reason, setReason] = useState("No access");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setReason("No access");
      setNote("");
    }
  }, [open, target?.runKey, target?.idx]);

  if (!open || !target) return null;

  const modal = (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md border border-gray-200">
        <div className="border-b border-gray-200 px-4 py-3">
          <h3 className="text-base font-semibold text-gray-900">Skip stop</h3>
        </div>
        <div className="p-4 space-y-3 text-sm">
          <p className="text-gray-700">
            You are about to skip:
            <span className="font-semibold">
              {" "}
              {target?.addr?.address || "Address"}
            </span>
          </p>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Reason (required)
            </label>
            <select
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-emerald-400 focus:border-emerald-400"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            >
              <option>No access</option>
              <option>Customer not home</option>
              <option>Unsafe to proceed</option>
              <option>Wrong address/details</option>
              <option>Vehicle issue</option>
              <option>Other</option>
            </select>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Notes (optional)
            </label>
            <textarea
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm min-h-[90px] focus:outline-none focus:ring-1 focus:ring-emerald-400 focus:border-emerald-400"
              placeholder="Add more details for the office"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>

          <div className="text-xs text-gray-500">
            Skipped stops appear in admin with your reason. They can be undone
            later.
          </div>
        </div>
        <div className="border-t border-gray-200 px-4 py-3 flex gap-2 justify-end">
          <button
            className="px-4 py-2 rounded-lg bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 transition"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-lg bg-amber-600 text-white text-sm font-medium hover:bg-amber-700 transition"
            onClick={() => onConfirm({ reason, note })}
          >
            Confirm skip
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
